import { createAsyncThunk } from '@reduxjs/toolkit';

import { buscarDefinicaoDoAgente, type Flow } from '@/features/negociacaoIndividualWizard';

import type { Config } from '../../types';
import { paraErroDaSimulacao } from '../falhasDaSimulacao';

export const buscarAgenteDaSimulacao = createAsyncThunk<Flow, string, Config>(
  'negociacaoSimulacao/buscarAgente',
  async (flowId, { getState, rejectWithValue }) => {
    if (!getState().auth.user?.empresaId) {
      return rejectWithValue({ ...paraErroDaSimulacao(null), mensagem: 'Não autenticado' });
    }
    try {
      return await buscarDefinicaoDoAgente(flowId);
    } catch (erro) {
      return rejectWithValue({
        ...paraErroDaSimulacao(erro),
        mensagem: erro instanceof Error ? erro.message : 'Erro ao carregar detalhes do agente',
      });
    }
  },
  {
    condition: (flowId, { getState }) => {
      const { formulario, trocandoEscritorio } = getState().negociacaoSimulacao;
      return !trocandoEscritorio && formulario.flowId === flowId;
    },
  },
);
